"use client"

import { Check, Copy01 } from "@untitledui/icons"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { useClipboard } from "@/hooks/use-clipboard"

interface ShareLinkChipProps {
  url: string
  heading?: string
  caption?: string
}

// `url` is server-resolved (`brief.canonical_url`) so the chip never falls
// back to `window.location.href` — that fallback misbehaves under SSR /
// off-window contexts (carve-up critique #11).
export function ShareLinkChip({
  url,
  heading = "Share this brief",
  caption = "Pass it to someone whose experience belongs in here.",
}: ShareLinkChipProps) {
  const [copiedText, copy] = useClipboard()
  const copied = copiedText === url

  return (
    <div className="border-secondary bg-primary flex flex-col gap-3 rounded-xl border p-6">
      <div className="flex flex-col gap-1">
        <h3 className="text-md text-primary font-semibold">{heading}</h3>
        <p className="text-tertiary text-sm">{caption}</p>
      </div>
      <div className="flex items-end gap-1.5">
        <div className="flex-1">
          <Input
            isReadOnly
            size="md"
            value={url}
            aria-label="Shareable link to this brief"
          />
        </div>
        <Button
          size="md"
          color="secondary"
          iconLeading={copied ? Check : Copy01}
          onClick={() => {
            void copy(url)
          }}
          aria-label={
            copied ? "Link copied to clipboard" : "Copy link to clipboard"
          }
        />
      </div>
    </div>
  )
}
